import ScreenCenter from "./ScreenCenter";

export default ScreenCenter;
